{
  "email_notifications": {
    "add_button": "New notification",
    "columns": {
      "alert_delay": "Alert delay",
      "child_site_alerts": "Managed site alerts",
      "format": "Format",
      "frequency": "Re-notification frequency",
      "recipient": "Recipient",
      "threshold": "Threshold"
    },
    "common": {
      "time": {
        "days": "Days",
        "hours": "Hours",
        "minutes": "Minutes",
        "seconds": "Seconds"
      }
    },
    "delete": {
      "cancel": "No, cancel",
      "confirm": "Yes, I'm sure",
      "success": "Your notification has been successfully deleted.",
      "title": "Are you sure you want to delete this notification?"
    },
    "email_type": {
      "html": "HTML",
      "plain": "Plain Text"
    },
    "form": {
      "fields": {
        "disable_alerts": {
          "description": "If enabled, you will receive email notifications containing alert details for all sites of which you are a direct member",
          "label": "Enable notifications about alerts"
        },
        "email_type": {
          "label": "Email Format",
          "options": {
            "html": "HTML",
            "plain": "Plain Text"
          }
        }
      }
    },
    "legacy_alert": {
      "alert_content": "Your account is currently using legacy alert notifications. Upgrade to our new risk-based alerts for improved accuracy, customization, and to avoid service interruptions.",
      "button": "Upgrade Now",
      "delete": {
        "cancel": "Cancel",
        "confirm_text": "Legacy alert notifications will be discontinued, and your account will be transitioned to risk-based alerts automatically.",
        "error": "There was an error while transitioning your account to risk-based alerts. Please try again later or contact support if the issue persists.",
        "submit": "Proceed",
        "success": "Your account has been successfully transitioned to risk-based alerts."
      }
    },
    "menu": {
      "aria_label": "Open email notification menu",
      "delete": "Delete notification",
      "edit": "Edit notification"
    },
    "modal": {
      "add": {
        "success": "You've successfully added a new notification.",
        "title": "Add new notification"
      },
      "edit": {
        "success": "Your notification has been successfully updated.",
        "title": "Edit notification"
      },
      "fields": {
        "child_site_alerts": {
          "label": "Receive managed site alerts"
        },
        "custom_email": {
          "label": "Custom email"
        },
        "email": {
          "invalid": "Invalid email address",
          "max_length": "Email must be at most 254 characters",
          "required": "Email is required"
        },
        "email_type": {
          "label": "Email Format",
          "options": {
            "html": "HTML",
            "plain": "Plain Text"
          }
        },
        "incident_delay": {
          "required": "Alert delay is required"
        },
        "incident_delay_measure": {
          "label": "Alert delay",
          "tooltip": "Time to wait before sending a notification when a site’s alert level changes."
        },
        "incident_frequency": {
          "required": "Re-notification frequency is required"
        },
        "incident_frequency_measure": {
          "label": "Re-notification frequency",
          "tooltip": "How often a notification is sent when an issue persists. A higher setting reduces the number of re-notifications."
        },
        "min": "{{label}} must be at least 60 seconds",
        "primary_email": {
          "label": "Primary email"
        },
        "required": "{{label}} is required",
        "risk_level": {
          "helper": "Notify when the site has medium and high severity alerts or when the site is down.",
          "label": "Notification threshold"
        },
        "time_units_label": "Select time unit"
      },
      "format_time": "Format and time",
      "recipient": "Recipient",
      "save": "Save",
      "threshold": "Threshold",
      "threshold_tooltip": "The alert threshold that must be met before the notification is sent."
    },
    "not_found": "No Email Notifications Found",
    "risk_level": {
      "high": {
        "helper": "Notify when the site has high severity alerts or the site is down.",
        "label": "High"
      },
      "low": {
        "helper": "Notify when the site has low, medium and high severity alerts or when the site is down.",
        "label": "Low"
      },
      "medium": {
        "helper": "Notify when the site has medium and high severity alerts or when the site is down.",
        "label": "Medium"
      },
      "site-outage": {
        "helper": "Notify only when the site is down.",
        "label": "Site Outage"
      }
    },
    "title": "Email alert notifications"
  },
  "header": "Welcome, {{name}}",
  "managed_user": {
    "back": "Back to users",
    "description": "You are managing settings for"
  },
  "subheader": "Here are your account settings",
  "token_management": {
    "create_token_dialog": {
      "create_token": "Create token",
      "header": "Provide description for your new token",
      "input_placeholder": "E.g. Third-party service"
    },
    "delete_token_dialog": {
      "confirm": "Yes, delete token",
      "message": "Are you sure you want to delete this token?",
      "success": "Token deleted"
    },
    "disable_management_dialog": {
      "cancel": "Cancel",
      "disable": "Disable",
      "line1": "Are you sure you want to disable token management for this user account?",
      "line2": "When you disable token management, all API tokens associated with this user will be permanently deleted."
    },
    "enable": "Enable token management",
    "new_token": "New token",
    "new_token_dialog": {
      "confirm": "Got it",
      "copy": "Copy",
      "description": "To ensure your security, we don't store API tokens in plaintext. Make sure to copy your API tokens now, as you won't be able to view them again. If you lose or forget your tokens, you'll need to revoke and regenerate them.",
      "header": "New API token has been created",
      "token_auth": "Token auth (password):",
      "token_description": "Token description:",
      "token_key": "Token key (username):",
      "warning": "Store your API token in a secure location"
    },
    "table": {
      "columns": {
        "created_at": "Created",
        "description": "Token description",
        "key": "Token key",
        "last_used_at": "Last Used"
      },
      "no_data": "No tokens found"
    },
    "title": "Token management",
    "title-tooltip": "Read more about token management <a>here</a>",
    "tokens-disabled": "We have a <b>Bigleaf Cloud Connect API</b> available for collecting automated site status information. To set up credentials, please contact your Super admin or <a>Bigleaf support</a>."
  },
  "user-info": {
    "error": {
      "error": "There was an error processing your request. This error has been logged and our support team will investigate.",
      "statuspage-failed": "Your statuspage subscription failed to save due to an issue with the statuspage provider, but your other changes have saved successfully.",
      "user-info-failed": "Your user information failed to save due to a server issue, but your statuspage subscription was saved successfully."
    },
    "fields": {
      "disable_alerts": {
        "label": "Disable alerts"
      },
      "email": {
        "invalid": "Invalid email address",
        "label": "Email",
        "max_length": "Email must be at most 254 characters",
        "placeholder": "Enter your email",
        "required": "Email is required"
      },
      "email_type": {
        "label": "Email Format",
        "options": {
          "html": "HTML",
          "plain": "Plain Text"
        }
      },
      "feature_opt_in": {
        "description": "Email me with new and upcoming features",
        "label": "Early feature access",
        "tooltip": "Allow Bigleaf to contact you about new and upcoming features and future Bigleaf plans."
      },
      "full_name": {
        "label": "Full name",
        "placeholder": "Enter your Full name",
        "required": "Full name is required"
      },
      "login": {
        "label": "Username",
        "max_length": "Username must be at most 32 characters",
        "placeholder": "Enter your Username",
        "required": "Username is required"
      },
      "monthly_reports": {
        "description": "If enabled, you will receive an email summarizing traffic insights for each site of which you are a member",
        "label": "Monthly reports"
      },
      "statuspage_subscribed": {
        "description": "Manage notification you receive",
        "label": "Statuspage subscription",
        "tooltip": "Get email notifications about upcoming maintenance and issues related to Bigleaf services. You can manage your components after subscribing."
      },
      "timezone": {
        "label": "Timezone",
        "no_results": "No timezones found"
      },
      "use_12_hour": {
        "12_hour_format": "12-hour",
        "24_hour_format": "24-hour",
        "label": "Time format"
      }
    },
    "reset_password": {
      "button": "Reset password",
      "modal": {
        "error_current": "Current password is incorrect",
        "fields": {
          "current": {
            "label": "Old password",
            "required": "Old password is required"
          },
          "hide": "Hide password",
          "new": {
            "duplicate": "New password can not be the same as old password",
            "invalid": "Password must be at least 8 characters with at least one uppercase and lowercase letter, number, and special character",
            "label": "New password",
            "required": "New password is required"
          },
          "new_repeat": {
            "label": "Repeat new password",
            "not_match": "The password doesn’t match",
            "required": "Repeat new password is required"
          },
          "show": "Show password"
        },
        "header": "Reset password",
        "requirements_message": "Must be at least 8 characters with at least one uppercase and lowercase letter, number, and special character.",
        "save": "Save",
        "success": "Your password has been successfully updated."
      }
    },
    "submit": "Save settings",
    "success": "Your information has been successfully updated. Your account is now up to date.",
    "title": "User information"
  }
}
